(function () {
  var root = document.getElementById('koko-pdp-reviews');
  if (!root || root.dataset.reviewLoaderInitialized === 'true') return;
  root.dataset.reviewLoaderInitialized = 'true';

  var observer = null;
  var loadPromise = null;
  var queuedAction = null;
  var replaying = false;

  function loadReviews() {
    if (root.dataset.reviewInitialized === 'true') return Promise.resolve();
    if (loadPromise) return loadPromise;
    if (observer) {
      observer.disconnect();
      observer = null;
    }

    loadPromise = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = root.dataset.reviewScriptSrc;
      script.async = true;
      script.onload = resolve;
      script.onerror = function () {
        loadPromise = null;
        reject(new Error('Unable to load reviews'));
      };
      document.head.appendChild(script);
    });
    return loadPromise;
  }

  function replayAction() {
    if (!queuedAction) return;
    var action = queuedAction;
    queuedAction = null;
    if (!action.target || !action.target.isConnected) return;
    replaying = true;
    try {
      if (action.type === 'submit' && typeof action.target.requestSubmit === 'function') {
        action.target.requestSubmit(action.submitter || undefined);
      } else if (action.type === 'change') {
        action.target.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (typeof action.target.click === 'function') {
        action.target.click();
      }
    } finally {
      replaying = false;
    }
  }

  function queueAction(event) {
    if (replaying || root.dataset.reviewInitialized === 'true') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!queuedAction) {
      queuedAction = {
        type: event.type,
        target: event.target,
        submitter: event.submitter || null,
      };
    }
    loadReviews().then(replayAction).catch(function () { /* Retry on the next interaction. */ });
  }

  root.addEventListener('pointerdown', function () {
    loadReviews().catch(function () { /* Retry on the next interaction. */ });
  }, { capture: true });
  root.addEventListener('focusin', function () {
    loadReviews().catch(function () { /* Retry on the next interaction. */ });
  }, { capture: true });
  ['click', 'change', 'submit'].forEach(function (eventName) {
    root.addEventListener(eventName, queueAction, true);
  });

  if (typeof IntersectionObserver === 'undefined') {
    loadReviews().catch(function () { /* Retry on the next interaction. */ });
  } else {
    observer = new IntersectionObserver(function (entries) {
      if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
      loadReviews().catch(function () { /* Retry on the next interaction. */ });
    }, { rootMargin: '600px 0px' });
    observer.observe(root);
  }
})();
